import { get, writable } from 'svelte/store';
import { VisitService } from '../../services/visit.service';
export const loading = writable(false);
export const dateFilter = writable("");
export const records = writable([]);
export const editingNote = writable(0);
export async function initList(date) {
    dateFilter.set(date);
    await load();
}
export async function load() {
    editingNote.set(0);
    loading.set(true);
    try {
        let _filter = {
            params: null,
            criteria: { query: "", refDate: get(dateFilter), showCompleted: 1 },
            sorting: ""
        };
        let _resp = await VisitService.getVisitItems(_filter);
        records.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
export async function markItemUnlockedGood(item) {
    await VisitService.markVisitItemUnlockedGood(item);
    await load();
}
export async function markItemUnlockedBurn(item) {
    await VisitService.markVisitItemUnlockedBurn(item);
    await load();
}
export function startEditingNote(item) {
    if (!item)
        return;
    editingNote.set(item.slaughterItemOid);
}
export async function saveNote(item) {
    if (!item) {
        await load();
        return;
    }
    await VisitService.saveVisitItemNotes(item);
    editingNote.set(0);
    await load();
}
